import React, { useCallback, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const editorConfig = {
  toolbar: [
    "heading",
    "|",
    "fontFamily",
    "bold",
    "italic",
    "fontBackgroundColor",
    "|",
    "alignment",
    "bulletedList",
    "numberedList",
    "outdent",
    "indent",
    "|",
    "link",
    "imageUpload",
    "undo",
    "redo",
    "removeFormat",
  ],
  image: {
    toolbar: ["imageTextAlternative", "imageStyle:full", "imageStyle:side"],
  },
  // Optional: set font family or height via config or CSS
};

const RichTextInput = ({
  meta,
  defaultValue,
  formInstance,
  dependencyValues,
}) => {
  const { key, rules = {} } = meta;
  const { control } = formInstance;
  const [display, setDisplay] = useState(true);

  const toggleVisibilityOfRichText = useCallback((condition) => {
    setDisplay(!condition);
  }, []);

  useEffect(() => {
    if (!meta.dependencies?.length || !Object.keys(dependencyValues).length)
      return;

    meta?.onDependencyValueChange(dependencyValues, meta.key, {
      toggleVisibilityOfRichText,
    });
  }, [meta, dependencyValues, toggleVisibilityOfRichText]);

  return (
    display && (
      <Controller
        control={control}
        name={key}
        defaultValue={defaultValue}
        shouldUnregister
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <div style={{ minHeight: 240 }}>
            <CKEditor
              editor={ClassicEditor}
              data={value || ""}
              config={editorConfig}
              onChange={(_, editor) => {
                const data = editor.getData();
                onChange(data);
              }}
            />
          </div>
        )}
      />
    )
  );
};

export default RichTextInput;
